module.exports = __webpack_public_path__ + "static/media/banner4.d3702e9e.jpg";